// Token aus dem Anmeldelink (/anmelden/link#…). Es wird schon vor dem ersten Rendern aus Adresszeile und Verlauf
// genommen (auch wenn /ich noch lädt oder scheitert) und nur im Speicher der Seite gehalten, bis die Person auf
// „Jetzt anmelden“ klickt.
export const LINK_PFAD = '/anmelden/link';

let token: string | null = null;

/** Übernimmt ein Token aus dem Fragment, wenn die Seite der Anmeldelink ist, und entfernt es aus der Adresszeile. */
export function tokenAusAdresseUebernehmen(): void {
  if (window.location.pathname !== LINK_PFAD || window.location.hash.length < 2) return;
  token = window.location.hash.slice(1);
  window.history.replaceState(window.history.state, '', window.location.pathname);
}

export function gemerktesToken(): string {
  return token ?? '';
}

/** Nach erfolgreicher oder endgültig abgelehnter Einlösung: Token verwerfen. */
export function tokenVergessen(): void {
  token = null;
}
